var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WidgetSettingsBaseForm',{ref:"form",attrs:{"widget":_vm.widget,"default-values":_vm.widget},on:{"values-changed":function($event){return _vm.baseFormValuesChanged($event)}}}),_vm._v(" "),_c(_vm.widgetSettingsComponent,{tag:"component",attrs:{"dashboard":_vm.dashboard,"widget":_vm.widget,"store-prefix":_vm.storePrefix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }